import { createContext, useContext } from 'react';
import { ICommonData } from './ICommonData';

export const CommonDataContext = createContext<ICommonData>({} as ICommonData);
export const CommonDataProvider = CommonDataContext.Provider;
export const useCommonData = () => useContext(CommonDataContext);
